import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class WebhooksAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'WEBHOOKS_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'WEBHOOKS_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'WEBHOOKS_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'WEBHOOKS_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess() {
    const message = {
      body: 'WEBHOOKS_CANCEL_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'WEBHOOKS_CANCEL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.webhooks')
  .service('webhooksAlerts', WebhooksAlerts);
